import {
  objectTemplatesGet,
  objectTemplatesCreate,
  objectTemplatesUpdate,
  objectTemplatesDelete
} from "@/api/objectTemplates.api";

import {
  OBJECT_TEMPLATES_READ,
  OBJECT_TEMPLATES_CREATE,
  OBJECT_TEMPLATES_UPDATE,
  OBJECT_TEMPLATES_DELETE,
  OBJECT_TEMPLATES_CLEAR
} from "../type";

const state = {
  objectTemplates: []
};

const getters = {};
const actions = {
  async [OBJECT_TEMPLATES_READ]({ commit }, { objectTypesId, lang }) {
    try {
      commit(OBJECT_TEMPLATES_CLEAR);
      const response = await objectTemplatesGet(objectTypesId, lang);
      commit(OBJECT_TEMPLATES_READ, response.data.objectTemplates);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECT_TEMPLATES_CREATE](undefined, { objectTypesId, lang, data }) {
    try {
      const response = await objectTemplatesCreate(objectTypesId, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECT_TEMPLATES_UPDATE](
    undefined,
    { objectTypesId, id, lang, data }
  ) {
    try {
      const response = await objectTemplatesUpdate(
        objectTypesId,
        id,
        lang,
        data
      );
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECT_TEMPLATES_DELETE](undefined, { objectTypesId, id }) {
    try {
      const response = await objectTemplatesDelete(objectTypesId, id);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {
  [OBJECT_TEMPLATES_READ](state, refs) {
    state.objectTemplates = refs;
  },
  [OBJECT_TEMPLATES_CLEAR](state) {
    state.objectTemplates = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
